import React from "react";
import { ListaAlcance } from "../../../components/ListaAlcance";

// Las semanas de producción y los periodos de inventario de almacén que entraron
// al cierre, que ya no vuelven a contarse en otro
export const AlcanceRegistrado = ({ cierre }) => {
    if (!cierre) return null;

    return (
        <div className="comparativo-mensual__alcance">
            <h5 className="comparativo-mensual__seccion-titulo">
                Periodo cerrado
            </h5>

            <div className="formulario-fields-row my-2">
                <ListaAlcance
                    titulo="Semanas de producción incluidas"
                    items={cierre.semanas.map(
                        (semana) => `${semana.etiqueta} (${semana.rango})`,
                    )}
                    vacio="Sin semanas registradas"
                />

                <ListaAlcance
                    titulo="Periodos de inventario de almacén incluidos"
                    items={cierre.periodos.map((periodo) => periodo.periodo)}
                    vacio="Sin periodos registrados"
                />
            </div>
        </div>
    );
};
